//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('priceLists', {
//        templateUrl: 'views/components/views/priceLists/priceLists.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'economyService', function (stateService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListPrices: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadPrices() {
//                vm.model.itemsListPrices = (await economyService.listPrices());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'pricelist':
//                        go({ pricelist_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadPrices();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
